module.exports = __webpack_public_path__ + "static/media/image15.36b09b2a.png";